import { StylesIndexInjections } from 'common-react';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    maxWidth: 151,
  },
  chart: {
    flexShrink: 0,
  },
  skeleton: {
    width: 151,
    height: 32,
    borderRadius: 4,
  },
  emptyLabel: {
    maxWidth: 151,
  },
}), { name: 'FundSmallChart', index: StylesIndexInjections.UI_MOLECULES });
